/**
 * HTTP Errors.
 */ const NOT_FOUND = '404: Not Found';
const UNAUTHORIZED = '401 Unauthorized';
/**
 * Unauthenticated Errors.
 */ const UNAUTHENTICATED = 'UNAUTHENTICATED';
/**
 * User Permission error.
 */ const USER_PERMISSION = 'USER_PERMISSION_ERROR';
const MISSING_ROLES = 'MISSING_ROLES';
/**
 * ReCAPTCHA Errors.
 */ const RECAPTCHA_ERROR = 'RECAPTCHA_ERROR';
/**
 * Error when certain action is forbidden e.g. MFA code invalid.
 */ const FORBIDDEN = 'FORBIDDEN';
/**
 * Error when MFA is required
 * but not provided.
 */ const MFA_REQUIRE = 'MFA_REQUIRE';
/**
 * Missing mock data error.
 */ const MISSING_MOCK_DATA = 'MISSING_MOCK_DATA_ERROR';
/**
 * Apollo built-in errors.
 * Https://www.apollographql.com/docs/apollo-server/data/errors#built-in-error-codes.
 */ const INTERNAL_SERVER_ERROR = 'INTERNAL_SERVER_ERROR';
const GRAPHQL_PARSE_FAILED = 'GRAPHQL_PARSE_FAILED';
const GRAPHQL_VALIDATION_FAILED = 'GRAPHQL_VALIDATION_FAILED';
const PERSISTED_QUERY_NOT_FOUND = 'PERSISTED_QUERY_NOT_FOUND';
const PERSISTED_QUERY_NOT_SUPPORTED = 'PERSISTED_QUERY_NOT_SUPPORTED';
const BAD_USER_INPUT = 'BAD_USER_INPUT';
const OPERATION_RESOLUTION_FAILURE = 'OPERATION_RESOLUTION_FAILURE';
const BAD_REQUEST = 'BAD_REQUEST';

export { BAD_REQUEST, BAD_USER_INPUT, FORBIDDEN, GRAPHQL_PARSE_FAILED, GRAPHQL_VALIDATION_FAILED, INTERNAL_SERVER_ERROR, MFA_REQUIRE, MISSING_MOCK_DATA, MISSING_ROLES, NOT_FOUND, OPERATION_RESOLUTION_FAILURE, PERSISTED_QUERY_NOT_FOUND, PERSISTED_QUERY_NOT_SUPPORTED, RECAPTCHA_ERROR, UNAUTHENTICATED, UNAUTHORIZED, USER_PERMISSION };
//# sourceMappingURL=codes.js.map
